import React from 'react';

export type ConversationalAnalyticsNotImplementedProps = {
  markType: string;
};

const ConversationalAnalyticsNotImplemented: React.FC<
  ConversationalAnalyticsNotImplementedProps
> = ({ markType }) => {
  return <div>{`Charts of type "${markType}" are not supported...`}</div>;
};

export default ConversationalAnalyticsNotImplemented;
